import { Button } from '@/components/atoms/NewPcButton';
import { useMembershipReviewPreviewTutorial } from '@/components/membership/MembershipReviewPreviewTutorial';

import { useToast } from '@/hooks/V3/useToast';

import { CPLAT_API_ROUTES } from '@/api';
import { useAppSelector } from '@/redux/store';
import { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/atoms/Dialog';

import { usePost } from '@/api';

import { AnswerControllerProps } from './AnswerController';

type PickedAnswerControllerProps = Pick<AnswerControllerProps, 'review' | 'setComment'>;

const GenerateAnswer = ({ review, setComment }: PickedAnswerControllerProps) => {
  const [open, setOpen] = useState(false);
  const [aiRecommendations, setAiRecommendations] = useState<string[]>([]);
  const { mutate: generateAIComment, isPending: isAILoading } = usePost(
    CPLAT_API_ROUTES.getReviewCommentRecommendation,
  );

  const user = useAppSelector((state) => state.user);
  const { showToast } = useToast();
  const { openTutorial } = useMembershipReviewPreviewTutorial();

  const handleAIGenerate = () => {
    if (openTutorial('generateAnswer')) return;

    setOpen(true);
    generateAIComment(
      {
        CplatToken: user.CplatToken,
        CommentCount: 3,
        Content: review.Content,
      },
      {
        onSuccess: (response) => {
          if (response.data?.data?.[0]?.RecommendationCommentList) {
            setAiRecommendations(response.data.data[0].RecommendationCommentList);
          }
        },
        onError: () => {
          showToast('warning', 'AI 답변 생성에 실패했습니다.');
          setOpen(false);
        },
      },
    );
  };

  const handleSelectRecommendation = (text: string) => {
    setComment?.(text);
    setOpen(false);
  };

  return (
    <>
      <Button
        variant="secondary"
        onClick={handleAIGenerate}
        size="xsmall"
        disabled={isAILoading}
        isLoading={isAILoading}
      >
        AI로 답변 생성
      </Button>

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent noCloseBtn>
          <DialogHeader>
            <DialogTitle>AI 답변 추천</DialogTitle>
          </DialogHeader>
          {isAILoading ? (
            <div className="flex h-40 items-center justify-center">
              <div className="h-8 w-8 animate-spin rounded-full border-4 border-blue-500 border-t-transparent" />
            </div>
          ) : (
            <div className="space-y-4">
              {aiRecommendations.map((text, idx) => (
                <button
                  key={idx}
                  type="button"
                  onClick={() => handleSelectRecommendation(text)}
                  className="w-full cursor-pointer rounded border p-4 text-left hover:bg-gr-50"
                >
                  {text}
                </button>
              ))}
            </div>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
};

export default GenerateAnswer;
